import type { UiStrings } from '@/constants/ui-locale'
import { fmt } from '@/constants/ui-locale'

export type ReviewConfidenceTier = 'high' | 'medium' | 'low'

/**
 * Approximate Figma “confidence” badges until compose exposes a real score.
 * More meetings → higher tier.
 */
export function reviewConfidenceTier(meetings: number): ReviewConfidenceTier {
  if (meetings >= 3) return 'high'
  if (meetings >= 2) return 'medium'
  return 'low'
}

export function reviewConfidenceLabel(tier: ReviewConfidenceTier, t: UiStrings): string {
  switch (tier) {
    case 'high':
      return t.projectDetailDictReviewConfidenceHigh
    case 'medium':
      return t.projectDetailDictReviewConfidenceMedium
    default:
      return t.projectDetailDictReviewConfidenceLow
  }
}

export function reviewAppearedLine(
  count: number,
  lastSeenFormatted: string | null,
  t: UiStrings
): string {
  if (lastSeenFormatted) {
    return fmt(t.projectDetailDictReviewAppearedSummary, {
      count,
      lastSeen: lastSeenFormatted,
    })
  }
  return fmt(t.projectDetailDictReviewAppearedCountOnly, { count })
}
